import { useSelector } from 'react-redux';

import * as ProjectsV2Store from '../../redux/projectsV2';
import useDispatchOnMount from '../useDispatchOnMount';

/**
 * This hook will fetch and return the organization's labels through the Projects v2 Redux store on mount.
 * @returns The list of `Label` objects for the org.
 * @deprecated - This pattern is outdated -- use useAsyncValue and friends (like useAsyncRequest) instead.
 */
const useOrgLabels = () => {
  useDispatchOnMount(ProjectsV2Store.actions.fetchOrganzationLabels);

  return useSelector(ProjectsV2Store.selectors.getOrganizationLabels);
};

export default useOrgLabels;
